export type Step = "chooseOffer" | "signUp" | "verification" | "confirmation"
export const stepOrder = [
  "chooseOffer",
  "signUp",
  "verification",
  "confirmation",
]
